import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomWarning } from '../../../custom-warning/custom-warning.component';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
	selector: 'app-dynamic-text',
	templateUrl: './dynamic-text.component.html',
	styleUrls: ['./dynamic-text.component.scss'],
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective }
	]
})
export class DynamicTextComponent {
	@Input() field: any;
	@Input() customWarning?: CustomWarning = { shouldRender: false, message: '' };
	@Output() lostFocus: EventEmitter<string> = new EventEmitter<string>();

	constructor(public controlContainer: ControlContainer) {}

	onBlur() {
		this.lostFocus.emit();
	}
}
